import React from 'react';
import { Box } from '@mui/material';
import { User } from '../../types';

interface AVRequestsProps {
  user?: User;
}

const AVRequests: React.FC<AVRequestsProps> = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ width: '100%', height: '600px' }}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSf8DYFUCMMT_-lA44TBNwYP7WIKqSkHv2Y6JX70wN0aa5jHtg/viewform?embedded=true"
          width="100%"
          height="600"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          title="AV Request Form"
        >
          Loading…
        </iframe>
      </Box>
    </Box>
  );
};

export default AVRequests;
